import { FC, useEffect, useState, useMemo, ReactNode } from 'react';

import { classNameBuilder } from '../../../utils/className';

import './Vacancies.scss';
import { DownArrow, RightArrowOutline } from '../../../assets/icons/svgIconsForJSX';
import { vacancyManager } from '../../../services/vacancyService';
import { IVacancyDictionariesArea } from '../../../models/Dictionaries/IVacancyDictionariesArea';

interface IProps {
    isSearch?: boolean;
    isDark?: boolean;
    repeatCount?: number;
    hasTitle?: boolean;
    basicPadding?: boolean;
    title?: string;
    titleVariant?: 'h2' | 'h3';
    showFooter?: boolean;
    isCenter?: boolean;
    more?: {
        buttonMore?: boolean;
        buttonText?: 'Загрузить еще' | 'Все вакансии' | 'Все стажировки';
        onClick?: any;
    };
    rotateArrow?: boolean;
    totalElements?: number;
    totalAllElements?: number;
    children: (props: { [key: string]: string }) => ReactNode;
}

const Vacancies: FC<IProps> = ({
    isSearch = false,
    isDark = false,
    children,
    repeatCount = 4,
    hasTitle = true,
    basicPadding = true,
    title,
    titleVariant = 'h2',
    showFooter = true,
    more = { buttonText: 'Загрузить еще' },
    rotateArrow = false,
    isCenter = false,
    totalElements,
    totalAllElements,
}) => {
    const cn = classNameBuilder('vacancies');
    const TypographyTag = titleVariant;

    const [jobDirectionTypes, setJobDirectionTypes] = useState<IVacancyDictionariesArea[]>();

    useEffect(() => {
        vacancyManager.getVacanciesReferences().then((response) => {
            setJobDirectionTypes(response.data.result.jobDirectionTypes);
        });
    }, []);

    const dictionaries: { [key: string]: string } = useMemo(() => {
        if (jobDirectionTypes) {
            return jobDirectionTypes.reduce((acc: any, el: any) => {
                acc[el.id] = el.name;
                return acc;
            }, {});
        }
        return [];
    }, [jobDirectionTypes]);

    return (
        <div className={cn(basicPadding ? 'basic-padding' : '', { isDark })}>
            {hasTitle && (
                <div className={cn('head')}>
                    <TypographyTag className={cn(`title-${titleVariant}`)}>{title}</TypographyTag>
                    {isSearch && <div>Search field</div>}
                </div>
            )}
            <div className={cn('body', { repeatCount: repeatCount })}>{children(dictionaries)}</div>

            {showFooter && (
                <div className={cn('foot', { center: isCenter })}>
                    {more?.buttonMore ? (
                        <div onClick={more.onClick} className={cn('foot-all')}>
                            {more.buttonText}
                            <RightArrowOutline className={cn('iconDownArrow')} />
                        </div>
                    ) : (
                        <div className={cn('foot-more')}>
                            {totalElements !== totalAllElements && (
                                <div onClick={more?.onClick} className={cn('more')}>
                                    {more?.buttonText}
                                    <DownArrow
                                        className={cn('iconDownArrow', { rotate: rotateArrow })}
                                    />
                                </div>
                            )}
                            <div className={cn('count')}>
                                Предложений: <span>{totalElements}</span> из {totalAllElements}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Vacancies;
